import React from 'react';
import Chat from 'containers/chat';

function ChatPage() {
  return <Chat />;
}

export default ChatPage;
